import Vue from 'vue';

Vue.component("location-google-map-component", {
    props: {
        mapCenterLat: Number,
        mapCenterLong: Number,
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            map: null
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.init();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            EventBus.$once("google-maps-ready", this.initMap);

            this.intersect();
        },

        /**
         * Initialize the Google Map
         *
         * @return {Void}
         */
        initMap() {
            const mapStyle = [
                {
                    featureType: "all",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "all",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#c2dfde"
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "off"
                        },
                    ]
                },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#eeede8"
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#FFFFFF"
                        },
                        {
                            lightness: 17
                        }
                    ]
                }

            ];

            this.map = new google.maps.Map(document.getElementById("gmap"), {
                zoom: 17,
                center: { lat: this.mapCenterLat, lng: this.mapCenterLong },
                styles: mapStyle,
                scrollwheel: false,
                // disableDefaultUI: true
                mapTypeControl: false,
            });

            var latlng = new google.maps.LatLng(this.mapCenterLat, this.mapCenterLong);
            var marker = new google.maps.Marker({
                position: latlng,
                map: this.map,
            });
        },

        intersect() {
            var options = {
                rootMargin: "300px",
                threshold: 0
            };

            var map = document.getElementById("map");

            var observer = new IntersectionObserver((entries, observer) => {
                var isIntersecting =
                    typeof entries[0].isIntersecting === "boolean"
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.injectGoogleMaps();
                    observer.unobserve(map);
                }
            }, options);

            observer.observe(map);
        },

        /**
         * Injects the Google Maps scripts when it is not there yet.
         *
         * @return {Void}
         */
        injectGoogleMaps() {
            var tag = document.createElement("script");
            tag.setAttribute("type", "text/javascript");
            tag.defer = true;
            tag.async = true;
            tag.setAttribute(
                "src",
                "//maps.google.com/maps/api/js?key=AIzaSyBK_DQTatWm6lrFfCyoyp66rz8JI5q_F0M&callback=mapsCallback"
            );
            (
                document.getElementsByTagName("head")[0] ||
                document.documentElement
            ).appendChild(tag);
        },

        /**
         * Raised when zoom in button of the map is clicked.
         *
         * @param   {Event}
         * @returns {Void}
         */
        onMapZoomInClick(event) {
            this.map.setZoom(this.map.getZoom() + 1);
        },

        /**
         * Raised when the zoom out button of the map is clicked.
         *
         * @param {Event} event
         * @returns {Void}
         */
        onMapZoomOutClick(event) {
            this.map.setZoom(this.map.getZoom() - 1);
        }
    }
});
